import { createPopper } from '@popperjs/core';

export default function () {
    const button = document.querySelector('.account-menu__btn');
    const popover = document.querySelector('.account-menu__popup');

    if (!button || !popover) {
        return;
    }

    const instance = createPopper(button, popover, {
        placement: 'bottom',
        modifiers: [
            {
                name: 'preventOverflow',
                options: {
                    boundary: 'viewport',
                },
            },
        ],
    });

    new ResizeObserver(() => instance.update()).observe(popover); // eslint-disable-line
}
